// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","565":"component---src-templates-page-js","774":"framework"}[chunkId] || chunkId) + "-" + {"532":"9a44b0c96edc28263ac1","565":"204b9be21a43d36860db","589":"995ef3d068ebf41d031a","774":"eb2a7d41368a200288ad"}[chunkId] + ".js";
};